export const INTERACTION_CUSTOM_EVENT_NAME = 'user_activation::interaction';

export const HttpStatusCode = {
    OK: 200,
    SERVER_ERROR: 500,
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404
};

export const STEP_IDS = {
    RESEND_EMAIL_STEP: 'resend_email_step',
    UPDATE_EMAIL_STEP: 'update_email_step'
};

export const FLOWS_STEPS = {
    USER_ACTIVATION: [
        { id: STEP_IDS.RESEND_EMAIL_STEP },
        { id: STEP_IDS.UPDATE_EMAIL_STEP }
    ]
};
